import React from 'react';
import './PrivacySection.scss';

const PrivacySection = () => (
  <section className="section" id="privacy-section">
    <div className="columns is-mobile is-multiline">
      <div className="column is-12-mobile is-3-tablet is-2-desktop">
        <img alt="acc_logo" height="50px" src="imgs/logos/acc_small_arrow.png" width="50px" />
      </div>
      <div className="column is-6-mobile is-3-tablet is-2-desktop">
        <a
          href="https://www.accenture.com/sk-en/about/privacy-policy"
          rel="noopener noreferrer"
          target="_blank">
          Privacy Statement
        </a>
      </div>
      <div className="column is-6-mobile is-3-tablet is-2-desktop">
        <a
          href="https://www.accenture.com/sk-sk/company-cookies-similar-technology"
          rel="noopener noreferrer"
          target="_blank">
          Cookie Policy
        </a>
      </div>
      <div className="column" />
    </div>
  </section>
);

export default PrivacySection;
